import './App.css';
import { Analytics } from '@vercel/analytics/react';
import Footer from './components/footer/Footer';
import Navbar from './components/navbar/NavBar';
import RouteHandler from './routes';
import { BrowserRouter } from 'react-router-dom';
import { useState } from 'react';
import CookieChoices from './components/cookieChoices/CookieChoices';

function App() {
  const [showCookieSettings, setShowCookieSettings] = useState(false);

  return (
    <BrowserRouter>
      <Analytics />
      <div className='FullScreen'>
        <Navbar />
        <RouteHandler />
        <Footer onCookieSettings={() => setShowCookieSettings(true)} />
      </div>
      <CookieChoices
        showSettings={showCookieSettings}
        onCloseSettings={() => setShowCookieSettings(false)}
      />
    </BrowserRouter>
  );
}

export default App;
